<template>

<v-content> 
	
			<v-row justify="center" align="start">
				<v-col class="colpad" cols="12">

					<div v-for="category in categories" :key="category.id">
						<!-- recorrido padre : categories -->
						<h3>{{ category.name }} {{ category.subtitle}} </h3> 
<hr>
								<!-- recorrido hijos : category > Items -->
								<v-list three-line>
									<div v-for="item in items" :key="item.id">
										<v-list-item v-if="item.category_id === category.id">
											<v-list-item-content>


												<p align="left" class="name" v-html="item.name"></p><hr>
												<p align="left" class="description"  v-html="item.description"></p>
												<p align="left" class="description"  v-html="item.description1"></p>
												<p align="left" class="description"  v-html="item.description2"></p>



												<v-row  class=" px-2 ">
											<p   v-for="aler in  item.alergenos" :key="aler.id" > 
											<img style=" max-width: 24px; margin: 4px;" class="alergenos" :src="`/static/alergenos/${aler}.jpg`" />
											</p>
								
											</v-row>
											</v-list-item-content>
											<v-list-item-icon>
												<div d-flex flex-column>
													<div style="text-align: right;" v-html="item.price"></div>
													<div style="text-align: right;" v-html="item.price2"></div>
												</div>
											</v-list-item-icon>
											
										</v-list-item>
									</div>					
								</v-list>
										
					</div>
				</v-col>
			</v-row>

          <v-spacer class="pa-10" ></v-spacer>
</v-content>

</template>

<script>
	import { mapState, mapActions } from "vuex";
	import {db} from '@/main';
	export default {
		mounted(){
			//console.log(this.$route.params.id)
			if ( this.$route.params.id == null ) { this.$router.push('/') }
			this.getBussiness(this.$route.params.id)
			if (this.bussiness !== '' ) {
				this.getCategories(this.$route.params.id)
				this.getItems(this.$route.params.id)
			}
			

		},
		data: () => ({
			loaded: false,
			bussiness: {},
			categories: [],
			items: []
		}),
		methods: {
			// Busco el negocio
			async getBussiness(bussiness_id){
				await db.collection('bussiness').doc(bussiness_id)
				  .get()
					.then( (snap) => {
							if (snap.exists) {
								this.bussiness = snap.data()
							} else {
								this.$router.push('/')
							}
					})
			}, //.getBusiness

			// Busco las categorias y las cargo en el array categories
			async getCategories(bussiness_id){
				let cats = []
				await db.collection('bussiness').doc(bussiness_id)
					.collection('categories').where('visible','==', true).orderBy('order')
					.onSnapshot(snap => {
						snap.forEach(doc => {
							cats.push({ id: doc.id, ...doc.data() })
						})
						this.categories = cats;
					})

			}, //.getCategories

			// Busco los items y los cargo en el array item
			async getItems(bussiness_id){
				let its = []
				await db.collection('bussiness').doc(bussiness_id)
					.collection('items').where('visible','==', true).orderBy('order')
					.onSnapshot(snap => {
						snap.forEach(doc => {
							its.push({ id: doc.id, ...doc.data() })
						})
						this.items = its;
						this.loaded = true;
					})

			}, //.getCategories



		}, //.methods
		computed: {
			...mapState(['bussinessId']),
		}


		
	}
</script>

<style>
#blocks{
   
    display: block !important;
}

.colpad {
padding: 0 !important;

}

.name {
font-size: 15px;


}
</style>